(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ba-showcase').forEach(function (section) {
    const track = section.querySelector('[data-ba-track]');
    const prev = section.querySelector('[data-ba-prev]');
    const next = section.querySelector('[data-ba-next]');
    const dotsWrap = section.querySelector('[data-ba-dots]');
    const items = section.querySelectorAll('.ba-showcase__item');

    if (dotsWrap) {
      items.forEach((item, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ba-showcase__dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', () => {
          items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsWrap || !track) return;
      const dots = dotsWrap.querySelectorAll('.ba-showcase__dot');
      const index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function updateNav() {
      if (!prev || !next || !track) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (track) {
      track.addEventListener('scroll', () => { updateDots(); updateNav(); });
      updateNav();
    }

    if (prev) prev.addEventListener('click', () => {
      const w = track.querySelector('.ba-showcase__item')?.offsetWidth || 300;
      track.scrollBy({ left: -(w + 24), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', () => {
      const w = track.querySelector('.ba-showcase__item')?.offsetWidth || 300;
      track.scrollBy({ left: w + 24, behavior: 'smooth' });
    });

    section.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
      const before = slider.querySelector('[data-ba-before]');
      const handle = slider.querySelector('[data-ba-handle]');
      const afterImg = slider.querySelector('.ba-slider__after img');
      const beforeImg = slider.querySelector('.ba-slider__before img');
      let dragging = false;

      function setWidth(px) {
        const rect = slider.getBoundingClientRect();
        let pct = (px / rect.width) * 100;
        pct = Math.max(4, Math.min(96, pct));
        before.style.width = pct + '%';
        handle.style.left = pct + '%';
      }

      function syncImgWidth() {
        const w = slider.getBoundingClientRect().width + 'px';
        if (afterImg) afterImg.style.width = w;
        if (beforeImg) beforeImg.style.width = w;
      }
      syncImgWidth();
      window.addEventListener('resize', syncImgWidth);

      function onMove(clientX) {
        const rect = slider.getBoundingClientRect();
        setWidth(clientX - rect.left);
      }

      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        onMove(e.clientX);
      });
      handle.addEventListener('pointerup', function () { dragging = false; });
      handle.addEventListener('pointercancel', function () { dragging = false; });

      slider.addEventListener('click', function (e) {
        if (e.target.closest('[data-ba-handle]')) return;
        onMove(e.clientX);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tshirt-design"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.custom-print-section').forEach(function (section) {
    const track = section.querySelector('[data-carousel-track]');
    const prev = section.querySelector('.custom-print__arrow--prev');
    const next = section.querySelector('.custom-print__arrow--next');
    if (!track || !prev || !next) return;
    const scrollAmount = () => track.clientWidth;
    prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-carousel-section').forEach(function (section) {
    const track = section.querySelector('[data-carousel-track]');
    const nav = section.querySelector('[data-carousel-nav]');
    const prev = section.querySelector('.product-carousel__arrow--prev');
    const next = section.querySelector('.product-carousel__arrow--next');
    if (!track || !prev || !next || !nav) return;

    const scrollAmount = () => track.querySelector('.product-carousel__item')?.offsetWidth + 20 || 260;
    prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));

    function updateNavVisibility() {
      const canScroll = track.scrollWidth > track.clientWidth + 4;
      nav.classList.toggle('is-hidden', !canScroll);
    }

    function updateArrowState() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= maxScroll - 4;
    }

    updateNavVisibility();
    updateArrowState();

    track.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', () => {
      updateNavVisibility();
      updateArrowState();
    });

    if (window.ResizeObserver) {
      new ResizeObserver(() => {
        updateNavVisibility();
        updateArrowState();
      }).observe(track);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
